$(document).on("ready", function(){
    Proj.initMain();
    Proj.FancyBox();
    Proj.blockPrint('.js-print');
    Proj.blockMap('.js-map');
    Proj.prodFilter('.js-filter');
    Proj.Modal();
    Order.init({
        basketBlockSelector : '#basket-block',
        basketButtonsSelector : '.btn-buy',
        basketTableSelector : '#basket-table',
        basketCheckout : '#basket-checkout'
    });
    /* Установка целей для систем аналитики */
    Proj.Targets.init([
        // Просмотр видео
        {
            selector: '[data-goal=send_mail]',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'send_mail');
            }
        },
        {
            selector: '.btn-buy',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'basket');
            }
        },
        {
            selector: '#next-btn',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'basket_order');
            }
        },
        {
            selector: '#next-btn-data',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'basket_data');
            }
        },
        {
            selector: '#send-btn',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'basket_confirm');
            }
        },
        {
            selector: '.js-print',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'print');
            }
        },
        {
            selector: '.js-prices',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'price');
            }
        },
        {
            selector: '.order-jumbotron-link',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'products');
            }
        },
        {
            selector: '.btn-click',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'form_1_cilck_open');
            }
        },
        {
            selector: '.btn-question',
            method: 'click',
            immediate: true,
            fn: function() {
                Proj.yaReachGoal('39512360', 'form_question_open');
            }
        },
    ]);
});